<template>
    <v-container fluid class="pa-6">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <!-- <v-btn v-if="dataset.data.status == 0 && dataset.data.enable_contradictory == 2" type="button" elevation="0" color="primary"
                            @click="updateContradictory" :loading="dataset.loading">Salvar</v-btn> -->
                            <v-btn v-if="isContradictoryValid" type="button" elevation="0" color="primary" @click="updateContradictory" :loading="dataset.loading">Salvar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                            to="/divergencias">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row v-if="!isContradictoryValid">
            <v-col>
                <v-banner single-line outlined>
                    <v-icon slot="icon" color="warning" size="36">mdi-alert-outline</v-icon>
                    Prazo para enviar contraditórios está encerrado!
                </v-banner>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm" v-if="dataset.data && dataset.data.user">
            <v-row>
                <v-col cols="12">
                    <v-row>
                        <v-col cols="12">
                            <v-card class="card-form-outlined">
                                <v-card-title class="card-group-title">Detalhes credor</v-card-title>
                                <v-card-text>
                                    <v-row>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense disabled id="name" label="Nome completo"
                                                v-model="dataset.data.user.name" required :rules="[$rules.required]"
                                                outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4">
                                            <v-text-field dense disabled label="E-mail" v-model="dataset.data.user.email"
                                                required outlined hide-details="auto">
                                            </v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-form>

        <v-row>
            <v-col cols="12">
                <v-row>
                    <v-col cols="12">
                        <v-card class="card-form-outlined" color="gray">
                            <v-card-title class="card-group-title">
                                <div class="title-container">
                                    <div class="title-block">
                                        <span id="title" class="table-card-title">Contraditório</span>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Descrição</p>
                                        <tiptap-vuetify
                                            :disabled="!isContradictoryValid"
                                            v-model="dataset.data.contradictory_reason" :rules="[$rules.required]"
                                            :extensions="extensions" hide-details="auto" />
                                        <div v-if="isContradictoryValid" class="text-caption grey--text mt-1">
                                            Para concordar com o pedido, basta escolher o status "Aprovado": descrição e documentos são opcionais.
                                        </div>
                                    </v-col>
                                    <v-col cols="12">
                                        <p class="font-weight-bold">Documentos</p>
                                        <!-- Documentos ja enviados no contraditorio -->
                                        <div v-if="contradictoryFiles.length" class="contradictory-files mb-3">
                                            <div v-for="doc in contradictoryFiles" :key="doc.id" class="contradictory-file">
                                                <v-icon small class="mr-2">{{ fileIcon(doc) }}</v-icon>
                                                <a href="#" class="contradictory-file__name" @click.prevent="openFile(`/api/client/files/contradictory-files/${doc.id}`, doc.name)">{{ doc.name }}</a>
                                                <span v-if="doc.size" class="text-caption grey--text ml-2">{{ formatSize(doc.size) }}</span>
                                                <v-spacer></v-spacer>
                                                <v-btn v-if="isContradictoryValid" icon small title="Remover documento"
                                                    :loading="removingFileId === doc.id" @click="removeContradictoryFile(doc)">
                                                    <v-icon small color="error">mdi-delete-outline</v-icon>
                                                </v-btn>
                                            </div>
                                        </div>
                                        <template v-if="isContradictoryValid">
                                            <v-file-input
                                                :key="fileInputKey"
                                                multiple
                                                dense
                                                outlined
                                                prepend-icon=""
                                                append-icon="mdi-paperclip"
                                                label="Adicionar documentos"
                                                placeholder="Selecionar documentos"
                                                hint="Cada arquivo com até 15 MB. Você pode selecionar vários de uma vez e adicionar mais depois."
                                                persistent-hint
                                                @change="addContradictoryFiles"
                                            ></v-file-input>
                                            <!-- Arquivos escolhidos (ainda nao enviados): o x tira o arquivo antes de enviar -->
                                            <div v-if="contradictoryNewFiles.length" class="mt-3 d-flex flex-wrap" style="gap: 6px;">
                                                <v-chip v-for="(doc, index) in contradictoryNewFiles" :key="fileKey(doc)"
                                                    small close close-icon="mdi-close" @click:close="removeNewFile(index)">
                                                    <v-icon left x-small>{{ fileIcon({ mime_type: doc.type, name: doc.name }) }}</v-icon>
                                                    {{ doc.name }}<span class="grey--text text--darken-1 ml-1">({{ formatSize(doc.size) }})</span>
                                                </v-chip>
                                            </div>
                                        </template>
                                        <div v-else-if="!contradictoryFiles.length" class="text-caption grey--text">Nenhum documento enviado.</div>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <p class="font-weight-bold">Status</p>
                                        <v-select
                                            :disabled="!isContradictoryValid"
                                            :items="dataset.statusOptions"
                                            item-text="text"
                                            item-value="value"
                                            v-model="dataset.data.contradictory_status"
                                            outlined
                                            dense
                                            hide-details="auto"
                                            label="Selecione o status"
                                            :rules="[$rules.required]"
                                        ></v-select>
                                    </v-col>

                                    <v-col cols="12" sm="6" v-if="dataset.data.contradictory_status == 2">
                                        <p class="font-weight-bold">Valor Aprovado (R$)</p>
                                        <v-text-field
                                            :disabled="!isContradictoryValid"
                                            v-model="formattedAmount"
                                            outlined
                                            dense
                                            hide-details="auto"
                                            label="Informe o valor aprovado"
                                            :rules="[$rules.required]"
                                        ></v-text-field>
                                    </v-col>

                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Solicitações de documentos</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-alert v-if="!dataset.data.official_letters || !dataset.data.official_letters.length" dense text type="info">
                            Nenhuma solicitação de documentos vinculada a esta Hab/Div.
                        </v-alert>

                        <v-expansion-panels v-else>
                            <v-expansion-panel v-for="(officialLetter, index) in dataset.data.official_letters" :key="officialLetter.id || index">
                                <v-expansion-panel-header>
                                    <v-row align="center">
                                        <v-col cols="12" md="3">
                                            <strong>Valor:</strong>
                                            R$ {{ officialLetter.amount | currency }}
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <strong>Solicitado em:</strong>
                                            {{ officialLetter.created_at | defaultDate("DD/MM/YYYY HH:mm:ss") }}
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <strong>Prazo contraditório:</strong>
                                            <span v-if="officialLetter.enable_contradictory == 2">
                                                {{ officialLetter.contradictory_deadline_at | defaultDate("DD/MM/YYYY", false, true) }}
                                            </span>
                                            <span v-else>Fechado</span>
                                        </v-col>
                                        <v-col cols="12" md="3">
                                            <v-chip :color="getOfficialLetterColor(officialLetter.status)" label text-color="white">
                                                {{ officialLetter.status | enum(dataset.officialLetterStatus, "id", "name") }}
                                            </v-chip>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row>
                                        <v-col cols="12">
                                            <p class="font-weight-bold">Análise</p>
                                            <div v-html="officialLetter.reason || 'N/A'"></div>
                                        </v-col>

                                        <v-col cols="12">
                                            <p class="font-weight-bold">Contraditório</p>
                                            <tiptap-vuetify
                                                :disabled="!canAnswerOfficialLetter(officialLetter)"
                                                v-model="officialLetter.contradictory_reason"
                                                :extensions="extensions"
                                                hide-details="auto" />
                                        </v-col>

                                        <v-col cols="12">
                                            <p class="font-weight-bold">Documento</p>
                                            <v-file-input
                                                :disabled="!canAnswerOfficialLetter(officialLetter)"
                                                :show-size="true"
                                                counter
                                                hint="O arquivo não pode ser superior a 15MB"
                                                dense
                                                prepend-icon=""
                                                outlined
                                                placeholder="Selecionar documento"
                                                :clearable="true"
                                                hide-details="auto"
                                                label="Adicionar documento"
                                                @change="onOfficialLetterFileSelected(officialLetter, $event)"
                                            />
                                            <v-row class="mt-n3" v-if="officialLetter.contradictory_reason_file_url">
                                                <v-col cols="12">
                                                    <v-btn type="button" elevation="0" color="primary" outlined
                                                        @click="openFile(`/api/client/files/official-letters/${officialLetter.id}/reason`, 'Documento do ofício')">
                                                        Visualizar documento
                                                    </v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        <v-col cols="12" class="text-right" v-if="canAnswerOfficialLetter(officialLetter)">
                                            <v-btn
                                                type="button"
                                                elevation="0"
                                                color="primary"
                                                :loading="officialLetter.loading"
                                                @click="updateOfficialLetterContradictory(officialLetter)">
                                                Salvar solicitação
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container">
                            <div class="title-block">
                                <span id="title" class="table-card-title">Negócios</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <v-row>
                                    <v-col>
                                        <strong>Habilitação/Divergência</strong>
                                        <br />
                                        <strong>Devedora: </strong> <span>{{ dataset.data.client ? dataset.data.client.name
                                            : '' }}</span>
                                        <br />
                                        <strong>Solicitado em</strong>
                                        <span>{{
                                            dataset.data.created_at | defaultDate('DD/MM/YYYY HH:mm:ss')
                                        }}</span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-expansion-panels>
                                            <v-expansion-panel v-for="(eventItem, eventIndex) in dataset.data.items"
                                                :key="eventIndex">
                                                <v-expansion-panel-header>
                                                    <div>
                                                        <strong>Origem:</strong>
                                                        <span>
                                                            {{
                                                                truncateText(
                                                                    eventItem.origin,
                                                                    30
                                                                )
                                                            }}
                                                        </span>
                                                        /
                                                        <strong>Valor:</strong>
                                                        <span v-if="eventItem.amount">
                                                            {{
                                                                eventItem.currency | enum(
                                                                    dataset.currencyTypes,
                                                                    'id',
                                                                    'currencyFormat'
                                                                )
                                                            }}
                                                            {{ eventItem.amount | currency }}
                                                        </span>
                                                        <span v-else>N/A</span>
                                                    </div>
                                                </v-expansion-panel-header>
                                                <v-expansion-panel-content>
                                                    <v-row>
                                                        <v-col>
                                                            <p>
                                                                <span class="section-info-title">Devedora</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ dataset.data.client.name }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Origem</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.origin }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Moeda</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{
                                                                        eventItem.currency
                                                                        | enum(
                                                                            dataset.currencyTypes,
                                                                            'id',
                                                                            'name'
                                                                        )
                                                                    }}
                                                                </span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Valor</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">{{
                                                                    eventItem.currency
                                                                    | enum(
                                                                        dataset.currencyTypes,
                                                                        'id',
                                                                        'currencyFormat'
                                                                    )
                                                                }}
                                                                    {{
                                                                        eventItem.amount | currency
                                                                    }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Observações</span>
                                                                <br />
                                                                <span class="section-info-value text-uppercase">
                                                                    {{ eventItem.observation }}</span>
                                                            </p>
                                                            <p>
                                                                <span class="section-info-title">Documentos</span>
                                                                <br />
                                                                <span class="section-info-value">{{
                                                                    eventItem.docs.length
                                                                }}
                                                                    arquivo(s)</span>
                                                            </p>
                                                            <v-row>
                                                                <v-col v-for="(
                                                                    doc, docIndex
                                                                ) in eventItem.docs" :key="docIndex" cols="12" sm="6" md="4" lg="3">
                                                                    <v-card
                                                                        outlined
                                                                        class="document-card"
                                                                        :class="{ 'document-card--disabled': !getDocId(doc) }"
                                                                        @click="openDoc(doc)"
                                                                    >
                                                                        <v-card-text class="d-flex align-center pa-3">
                                                                            <v-avatar size="40" color="primary" class="mr-3">
                                                                                <v-icon color="white">{{ getDocIcon(doc) }}</v-icon>
                                                                            </v-avatar>
                                                                            <div class="document-card__content">
                                                                                <div class="document-card__name">
                                                                                    {{ getDocName(doc) }}
                                                                                </div>
                                                                                <div class="document-card__action">
                                                                                    {{ getDocId(doc) ? 'Visualizar documento' : 'Documento indisponível' }}
                                                                                </div>
                                                                            </div>
                                                                        </v-card-text>
                                                                    </v-card>
                                                                </v-col>
                                                            </v-row>
                                                        </v-col>
                                                    </v-row>
                                                </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-divider></v-divider>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <document-viewer-dialog v-model="viewer.open" :source="viewer.source" :file-name="viewer.name" />
    </v-container>
</template>

<script>
import states from "@/common/data/states.data"
import string from "@/common/util/string"

import userTypes from "@/common/data/user-types.data"
import currencyTypes from "@/common/data/currency-types.data"

import axios from "axios"
import DocumentViewerDialog from "@/components/DocumentViewerDialog.vue"

import {
    TiptapVuetify, Heading, Bold, Italic, Strike, Underline, Code, Paragraph, BulletList, OrderedList, ListItem, Link, Blockquote, HardBreak, HorizontalRule, History, Table, TableCell, TableHeader,
    TableRow, TodoList, TodoItem
} from 'tiptap-vuetify'


export default {
    name: "UserDetails",

    components: { 'tiptap-vuetify': TiptapVuetify, DocumentViewerDialog },

    data: () => ({
        // Documentos novos escolhidos para o contraditorio (enviados ao salvar)
        contradictoryNewFiles: [],
        removingFileId: null,
        fileInputKey: 0,
        page: {
            isNew: false,
            title: "",
        },
        dataset: {
            userTypes: userTypes,
            currencyTypes: currencyTypes,
            breadcrumbItems: [],
            states: states,
            statusOptions: [
                { text: 'Aprovado', value: 1 },
                { text: 'Aprovado Parcialmente', value: 2 },
                { text: 'Rejeitado', value: 3 }
            ],
            officialLetterStatus: [
                { id: 0, name: "Pendente" },
                { id: 1, name: "Aprovado" },
                { id: 2, name: "Rejeitado" },
            ],
            data: {
                contradictory_reason: "",
                contradictory_status: null, 
                contradictory_amount: null,
                items: [],
                official_letters: []
            },
            events: []
        },
        dataForm: {
            validForm: true,
            addLoading: false,
            updateLoading: false,
            removeLoading: false,
            showPassword: false,
            showPasswordConfirmation: false,
        },
        // Visualizador: o arquivo vem da API na hora do clique (o link do storage vencia).
        viewer: { open: false, source: null, name: "" },
        extensions: [
            History,
            Blockquote,
            Link,
            Underline,
            Strike,
            Italic,
            ListItem,
            BulletList,
            OrderedList,
            [Heading, {
                options: {
                    levels: [1, 2, 3]
                }
            }],
            Bold,
            Code,
            HorizontalRule,
            Paragraph,
            HardBreak,
            [Table, {
                options: {
                    resizable: true
                }
            }],
            TableCell,
            TableHeader,
            TableRow,
        ],
    }),

    created() {
        this.loadData();
    },

    computed: {
        contradictoryFiles() {
            return (this.dataset.data && Array.isArray(this.dataset.data.contradictory_files)) ? this.dataset.data.contradictory_files : [];
        },
        isContradictoryValid() {
            if (!this.dataset.data || !this.dataset.data.contradictory_deadline_at) return false;
            return Number(this.dataset.data.enable_contradictory) === 2;
        },
        isContradictoryAgreement() {
            return Number(this.dataset.data && this.dataset.data.contradictory_status) === 1;
        },
        hasContradictoryReason() {
            const reason = this.dataset.data && this.dataset.data.contradictory_reason;
            return !!reason && String(reason).replace(/<[^>]*>|&nbsp;/g, "").trim().length > 0;
        },
        formattedAmount: {
            get() {
                let val = this.dataset.data.contradictory_amount;
                if (val === null || val === undefined || val === '') return '';
                
                return Number(val).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            },
            
            set(value) {
                if (!value) {
                    this.dataset.data.contradictory_amount = null;
                    return;
                }
                let unmasked = value.replace(/\D/g, '');
                
                this.dataset.data.contradictory_amount = Number(unmasked) / 100;
            }
        }
    },

    methods: {
        goBack() {
            this.$router.replace("/divergencias");
        },

        // Soma os arquivos escolhidos aos que ja estavam na lista (sem repetir o mesmo arquivo).
        addContradictoryFiles(files) {
            const picked = Array.isArray(files) ? files : (files ? [files] : []);
            picked.forEach((doc) => {
                if (!this.contradictoryNewFiles.some((item) => this.fileKey(item) === this.fileKey(doc))) {
                    this.contradictoryNewFiles.push(doc);
                }
            });
            // Zera o campo para a proxima selecao somar de novo.
            this.fileInputKey += 1;
        },

        removeNewFile(index) {
            this.contradictoryNewFiles.splice(index, 1);
        },

        fileKey(doc) {
            return `${doc.name}-${doc.size}-${doc.lastModified}`;
        },

        async removeContradictoryFile(doc) {
            const proceed = await this.$dialog.confirm({
                title: "Remover documento",
                text: `Remover o documento "${doc.name}" do contraditório?`,
                actions: { false: "Cancelar", true: "Remover" },
            });
            if (!proceed) return;
            this.removingFileId = doc.id;
            try {
                const response = await axios.delete(`/api/admin/user-events/contradictory/${this.$route.params.id}/files/${doc.id}`);
                this.$set(this.dataset.data, "contradictory_files", response.data.content || []);
                this.$dialog.notify.info("Documento removido.", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: "top-right", timeout: 3000 });
            } finally {
                this.removingFileId = null;
            }
        },

        fileIcon(doc) {
            const type = String(doc.mime_type || doc.name || "").toLowerCase();
            if (type.includes("pdf")) return "mdi-file-pdf-box";
            if (type.includes("image") || /\.(png|jpe?g|gif|webp)$/.test(type)) return "mdi-file-image-outline";
            return "mdi-file-outline";
        },

        formatSize(bytes) {
            const n = Number(bytes || 0);
            return n >= 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`;
        },

        onOfficialLetterFileSelected(officialLetter, file) {
            this.$set(officialLetter, "contradictory_reason_file", file);
        },

        getDocUrl(doc) {
            return doc && doc.doc ? doc.doc.file_url : null;
        },

        getDocId(doc) {
            return doc && doc.doc && doc.doc.id ? doc.doc.id : null;
        },

        getDocName(doc) {
            if (!doc || !doc.doc) return 'Documento';

            return doc.doc.name || doc.doc.original_name || doc.doc.file || 'Documento';
        },

        isImageDoc(doc) {
            const name = this.getDocName(doc).toLowerCase();
            const url = String(this.getDocUrl(doc) || '').toLowerCase();

            return /\.(png|jpe?g|gif|webp|bmp)(\?|$)/.test(name) || /\.(png|jpe?g|gif|webp|bmp)(\?|$)/.test(url);
        },

        getDocIcon(doc) {
            if (this.isImageDoc(doc)) return 'mdi-file-image-outline';

            const name = this.getDocName(doc).toLowerCase();
            if (name.endsWith('.pdf')) return 'mdi-file-pdf-box';
            if (/\.(doc|docx)(\?|$)/.test(name)) return 'mdi-file-word-outline';
            if (/\.(xls|xlsx|csv)(\?|$)/.test(name)) return 'mdi-file-excel-outline';

            return 'mdi-file-document-outline';
        },

        // Arquivos do contraditorio e do oficio: tambem no visualizador (sem link do storage).
        openFile(source, name) {
            this.viewer = { open: true, source, name: name || "Documento" };
        },

        openDoc(doc) {
            const id = this.getDocId(doc);
            if (!id) {
                this.$dialog.notify.error('Documento indisponível para visualização.', { position: 'top-right', timeout: 2000 });
                return;
            }
            this.viewer = { open: true, source: `/api/client/files/user-docs/${id}`, name: this.getDocName(doc) };
        },

        canAnswerOfficialLetter(officialLetter) {
            return officialLetter && Number(officialLetter.status) === 0 && Number(officialLetter.enable_contradictory) === 2;
        },

        getOfficialLetterColor(status) {
            switch (Number(status)) {
                case 0:
                    return "warning";
                case 1:
                    return "accent";
                case 2:
                    return "error";
                default:
                    return "grey";
            }
        },

        truncateText(text, maxLength) {
            
            if (!text) return 'N/A';
          
            return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
          
        },

        async loadData() {
            await this.load();
            this.setPage();
            this.listBreadCrumbItems();   
        },

        setPage() {
            this.page.isNew = this.$route.params.id === "novo";
            this.page.title = `Detalhes da ${this.dataset.data.user.uuid_ref ? 'divergência' : 'habilitação'}`;
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                {
                    text: "Homepage",
                    disabled: false,
                    to: "/home",
                    exact: true,
                },
            ];

            this.dataset.breadcrumbItems.push({
                text: "Divergência",
                disabled: false,
                to: "/divergencias",
                exact: true,
            })

            this.dataset.breadcrumbItems.push({
                text: `Detalhes da ${this.dataset.data.user.uuid_ref ? 'divergência' : 'habilitação'}`,
                disabled: true,
                exact: true,
            });
        },

        async updateContradictory() {
            if (!this.dataset.data.contradictory_status) {
                this.$dialog.notify.error("O Status é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            // Concordar (Aprovado) dispensa descrição e documento.
            if (!this.isContradictoryAgreement && !this.hasContradictoryReason) {
                this.$dialog.notify.error("Contraditório é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            if (this.dataset.data.contradictory_status === 2 && !this.dataset.data.contradictory_amount) {
                this.$dialog.notify.error("Informe o valor parcial aprovado", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja enviar o contraditório?`,
                title: `Enviar Contraditório`,
                actions: { false: 'Cancelar', true: 'Enviar' }
            })

            if (!proceedAction) return;

            this.dataset.loading = true;

            const formData = new FormData();
            formData.append("contradictory_reason", this.hasContradictoryReason ? this.dataset.data.contradictory_reason : "");
            formData.append("contradictory_status", this.dataset.data.contradictory_status);

            if (this.dataset.data.contradictory_status === 2) {
                formData.append("contradictory_amount", this.dataset.data.contradictory_amount);
            }

            const newFiles = Array.isArray(this.contradictoryNewFiles) ? this.contradictoryNewFiles : [];
            newFiles.forEach((doc) => formData.append('reasons[]', doc));

            try {
                const response = await axios.patch(`/api/admin/user-events/contradictory/${this.$route.params.id}`, formData);

                this.$dialog.notify.info(`Contraditório enviado com sucesso!`, { position: "top-right", timeout: 2000 });
                this.goBack()
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            } finally {
                this.dataset.loading = false;
            }
        },

        async updateOfficialLetterContradictory(officialLetter) {
            if (!officialLetter.contradictory_reason) {
                this.$dialog.notify.error("Contraditório é obrigatório", { position: "top-right", timeout: 2000 });
                return;
            }

            const proceedAction = await this.$dialog.confirm({
                text: `Deseja enviar o contraditório desta solicitação?`,
                title: `Enviar contraditório`,
                actions: { false: 'Cancelar', true: 'Enviar' }
            });

            if (!proceedAction) return;

            this.$set(officialLetter, "loading", true);

            const formData = new FormData();
            formData.append("contradictory_reason", officialLetter.contradictory_reason);

            if (officialLetter.contradictory_reason_file) {
                formData.append("reason", officialLetter.contradictory_reason_file);
            }

            try {
                await axios.patch(`/api/admin/official-letters/contradictory/${officialLetter.id}`, formData);
                this.$dialog.notify.info(`Contraditório enviado com sucesso!`, { position: "top-right", timeout: 2000 });
                await this.load();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 });
            } finally {
                this.$set(officialLetter, "loading", false);
            }
        },

        async load() {
            try {
                const result = await axios.get(`/api/admin/user-events/find/${this.$route.params.id}`);
                const data = result.data.content;

                this.dataset.data = {
                    ...this.dataset.data,
                    ...data,
                    smallReason: data.small_reason || "",
                    reason: data.reason || "",
                    contradictory_status: data.contradictory_status ? Number(data.contradictory_status) : null,
                    contradictory_amount: data.contradictory_amount || null
                };

            } catch (error) {
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 2000 })
            }
        },

    },
};
</script>
  
<style lang="scss">
.access-container {
    border: 1px solid var(--v-gray-base) !important;
}

.custom-chip {
    background: var(--v-white-base) !important;
}

.title-page {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

.section-info-title {
    color: var(--v-primary-base);
    // font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
}

.section-info-value {
    // font-family: Montserrat;
    font-size: 14px;
    font-style: normal;
}

.document-card {
    cursor: pointer;
    border-radius: 4px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.document-card:hover {
    border-color: var(--v-primary-base);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.document-card--disabled {
    cursor: not-allowed;
    opacity: 0.65;
}

.document-card__content {
    min-width: 0;
}

.document-card__name {
    color: var(--v-primary-base);
    font-size: 14px;
    font-weight: 700;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.document-card__action {
    color: #6b7280;
    font-size: 12px;
    font-weight: 500;
}

.contradictory-files {
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 4px 8px;
}

.contradictory-file {
    display: flex;
    align-items: center;
    padding: 4px 0;
}

.contradictory-file + .contradictory-file {
    border-top: 1px solid #f1f1f1;
}

.contradictory-file__name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>
